export default __webpack_public_path__ + "static/media/banner-midcap150.2140d776.jpg";